// Class: starling.textures.TextureSmoothing

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var TextureSmoothing = function(){}

// Meta

TextureSmoothing.__name__ = "starling.textures.TextureSmoothing";
TextureSmoothing.__isInterface__ = false;
TextureSmoothing.prototype = {
	
};
TextureSmoothing.prototype.__class__ = TextureSmoothing.prototype.constructor = $hxClasses["starling.textures.TextureSmoothing"] = TextureSmoothing;

// Init



// Statics

TextureSmoothing.isValid = function(smoothing) {
	if(!(smoothing == "none" || smoothing == "bilinear")) {
		return smoothing == "trilinear";
	} else {
		return true;
	}
}
TextureSmoothing.NONE = "none"
TextureSmoothing.BILINEAR = "bilinear"
TextureSmoothing.TRILINEAR = "trilinear"

// Export

exports.default = TextureSmoothing;